import React, { useMemo, useState } from "react";

/* Bento layout pattern — repeats every 12 items */
const SPANS = [
  { col: 2, row: 2 }, // hero large
  { col: 1, row: 1 },
  { col: 1, row: 1 },
  { col: 1, row: 2 }, // tall
  { col: 1, row: 1 },
  { col: 1, row: 1 },
  { col: 2, row: 1 }, // wide
  { col: 1, row: 1 },
  { col: 1, row: 1 },
  { col: 1, row: 1 },
  { col: 1, row: 1 },
  { col: 2, row: 1 }, // wide
];

function getSpan(i) {
  return SPANS[i % SPANS.length];
}

export default function MediaSection({
  mediaTab = "highlights",
  setMediaTab,
  highlightImages = [],
  groupImages = [],
  onOpenLightbox,
}) {
  const [hovered, setHovered] = useState(null);

  const items = useMemo(() => {
    const src = mediaTab === "highlights" ? highlightImages : groupImages;
    return src
      .filter((it) => it?.src)
      .slice(0, 12);
  }, [mediaTab, highlightImages, groupImages]);

  return (
    <section id="medias" className="section">
      <div className="container">

        <div className="media-header" data-reveal="up">
          <div>
            <span className="section-label">📸 Galerie</span>
            <h2 className="section-title">Médias</h2>
            <p className="section-sub">Ambiance, entraînements et compétitions en images.</p>
          </div>

          <div className="media-tabs">
            <button
              className={`media-tab ${mediaTab === "highlights" ? "active" : ""}`}
              onClick={() => setMediaTab?.("highlights")}
            >
              ⚡ Highlights
              <span className="tab-count">{highlightImages.length}</span>
            </button>
            <button
              className={`media-tab ${mediaTab === "group" ? "active" : ""}`}
              onClick={() => setMediaTab?.("group")}
            >
              👥 Groupe
              <span className="tab-count">{groupImages.length}</span>
            </button>
          </div>
        </div>

        {items.length === 0 ? (
          <div className="media-empty">Aucune image disponible.</div>
        ) : (
          <div className="bento-grid" data-reveal="up">
            {items.map((img, i) => {
              const { col, row } = getSpan(i);
              return (
                <button
                  key={img.src + i}
                  className={`bento-item ${hovered === i ? "is-hovered" : ""}`}
                  style={{ gridColumn: `span ${col}`, gridRow: `span ${row}` }}
                  type="button"
                  onClick={() => onOpenLightbox?.(img.src)}
                  onMouseEnter={() => setHovered(i)}
                  onMouseLeave={() => setHovered(null)}
                  aria-label="Agrandir la photo"
                >
                  <img
                    src={img.src}
                    alt={img.alt || ""}
                    loading={i < 4 ? "eager" : "lazy"}
                  />
                  <div className="bento-overlay">
                    <i className="fa-solid fa-expand bento-zoom" />
                  </div>
                </button>
              );
            })}
          </div>
        )}

      </div>
    </section>
  );
}
